import { TreeviewItem, TreeItem, TreeviewHelper } from 'ngx-treeview';
import { CommonJS } from './commonjs';

export module AngularTreeviewHelper {
    interface TreeviewLevel {
        value: any;
        children: any[];
        levels: any[];
    }

    export const TreeviewStatus = {
        NO_CHECK: 0,
        PARTIAL: 1,
        ALL_CHECK: 2
    }

    export function findItem(root: TreeviewItem, value: any): TreeviewItem { return TreeviewHelper.findItem(root, value); }
    export function findItemInList(list: TreeviewItem[], value: any): TreeviewItem { return TreeviewHelper.findItemInList(list, value); }
    export function findParent(root: TreeviewItem, item: TreeviewItem): TreeviewItem { return TreeviewHelper.findParent(root, item); }
    export function removeItem(root: TreeviewItem, item: TreeviewItem): boolean { return TreeviewHelper.removeItem(root, item); }
    export function concatSelection(items: TreeviewItem[], checked: TreeviewItem[], unchecked: TreeviewItem[]): {
        [k: string]: TreeviewItem[];
    } { return TreeviewHelper.concatSelection(items, checked, unchecked); }

    export function getTreeviewStatus(item: TreeviewItem): number {
        if (item.indeterminate) return 1;
        else return item.checked ? 2 : 0;
    }

    export function generateItemFromStrings(data: string[]): TreeviewItem[] {
        let items: TreeviewItem[] = null;
        if (data) {
            data = CommonJS.clone(data);
            items = new Array<TreeviewItem>();
            data.forEach(a => {
                let i: TreeItem = {
                    text: a,
                    value: a,
                    checked: false,
                    collapsed: true
                };
                items.push(new TreeviewItem(i));
            });
        }
        return items;
    }

    export function generateItemFromObjects(data: any[], valueField: string, textField: string, levelFields?: string[]): TreeviewItem[] {
        let items: TreeviewItem[] = null;
        if (data) {
            data = CommonJS.clone(data);
            items = new Array<TreeviewItem>();
            if (levelFields) {
                let levels: TreeviewLevel[] = new Array<TreeviewLevel>();
                _buildLevels(levels, levelFields, data, 0);
                _buildItems(items, levels, valueField, textField);
            } else {
                data.forEach(a => {
                    let i: TreeItem = {
                        text: a[textField],
                        value: a[valueField],
                        checked: false,
                        collapsed: true
                    };
                    items.push(new TreeviewItem(i));
                });
            }
        }
        return items;
    }

    function _buildLevels(levels: TreeviewLevel[], levelFields: any[], data: any[], depth: number) {
        if (depth == levelFields.length) return;
        let levelField = levelFields[depth];
        let levelValues = Array.from(new Set(data.map(a => a[levelField].toString()))).sort((a, b) => a.localeCompare(b));
        levelValues.forEach(e => {
            let l: TreeviewLevel = {
                value: e,
                children: data.filter(x => x[levelField] == e),
                levels: new Array<TreeviewLevel>()
            }
            _buildLevels(l.levels, levelFields, l.children, depth + 1);
            if (depth < levelFields.length - 1) delete l.children;
            else delete l.levels;
            levels.push(l);
        });
    }

    function _buildItems(items: TreeItem[], levels: TreeviewLevel[], valueField: string, textField: string) {
        levels.forEach(a => {
            let n: TreeItem = {
                text: a.value,
                value: a.value,
                checked: false,
                collapsed: true,
                children: new Array<TreeItem>()
            };
            if (a.levels) _buildItems(n.children, a.levels, valueField, textField);
            if (a.children) {
                a.children.forEach(b => {
                    let i: TreeItem = {
                        text: b[textField],
                        value: b[valueField],
                        checked: false,
                        collapsed: true
                    };
                    n.children.push(new TreeviewItem(i));
                })
            }
            items.push(new TreeviewItem(n));
        });
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/functions/treeview-helper.ts